


import Navbar from './components/navbar'
import Home from './components/home';
import Footer from './components/footer'
import Projects from './components/projects'
import Contact from './components/contact'

import './App.css';
import { Router,Routes, Route } from 'react-router-dom';
import About from './components/about';


function App() {
  return (
       <div id="App">
        
        <Navbar />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route
            path='/*'
            element={
              <>
                <Routes>
                  <Route path='/about' element={<About />} />
                  <Route path='/projects' element={<Projects />} />
                  <Route path='/contact' element={<Contact />} />
                </Routes>
                <Footer />
              </>
            }
          />
          </Routes>
          
      </div>
 
    
  );
}

export default App;
